import type { TypedMyHotelLocation } from './-MyHotelLocation';
import RawMyHotelLocation from './MyHotelLocation.vue';
export * from './-MyHotelLocation';
export const MyHotelLocation = RawMyHotelLocation as typeof TypedMyHotelLocation;
